import { render, staticRenderFns } from "./NovelFeedPage.vue?vue&type=template&id=01b3252a&scoped=true&"
import script from "./NovelFeedPage.vue?vue&type=script&lang=js&"
export * from "./NovelFeedPage.vue?vue&type=script&lang=js&"
import style0 from "./NovelFeedPage.vue?vue&type=style&index=0&id=01b3252a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3252a",
  null
  
)

export default component.exports